import React from 'react'
import Icon from "../../../assets/images/brush.png"

const Choose = () => {

	const points = [
		{
			title: "Attention to Detail",
			description: "We don’t just clean; we perfect. Our team takes the time to ensure every surface is immaculate."
		},
		{
			title: "Eco-Friendly Practises",
			description: "We use environmentally safe products to protect both your space and the planet."
		},
		{
			title: "Customised Solutions",
			description: "Every business is unique, and so are your cleaning needs. We provide personalized cleaning plans to suit your requirements."
		},
		{
			title: "Reliability You Can Trust",
			description: "We pride ourselves on our professionalism, punctuality, and commitment to excellence."
		}
	]

	return (
		<div>
			<div className="rs-choose choose-style1 pt-120 pb-120 md-pt-80 md-pb-50">
				<div className="container">
					<div className="align-items-start row y-middle">
						<div className="col-lg-6 md-mb-50">
							<div className="sec-title2">
								<div className="brush-content mb-20">
									<img src={Icon} alt="" />
									<span className="sub-text"> Why Choose US?</span>
								</div> 
								<div className="rs-features-list feature-style4">
									{points?.map((point, i) => {
										return (
											<div className="feature-item mb-3" key={i}>
												<div className="feature-icon">
													<i className="bi bi-check-lg"></i>
												</div>
												<div className="rs-feature-text">
													<h4 className="title mb-1">{point?.title}</h4>
													<p className="desc">{point?.description}</p>
												</div>
											</div>
										)
									})} 
								</div>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="about-choose-us">
								<div className="about-video">
									{/* <div className="rs-videos">
										<div className="animate-border">
			                                <a className="popup-border popup-videos" href="#">
			                                    <i className="bi bi-play-fill"></i>
			                                </a>
			                            </div>
									</div> */}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Choose
